module.exports = function getResource(label, vars = []) {
    let resources = {
        relatedLinksLabel: 'Related Pages'
    };
    return resources[label];
};
